export class Busqueda {
  
    fechaDesde: string;
    fechaHasta: string;
    modelo: string;
    tipoVenta: string;
    cuil: string;
    pcn: string;
  }

  export class Models {
    cuil: string;
    dni: string;
    pcn: string;
    modelo: string;
    tipoVenta: string;
    funcion:string;
    fecha: string;
    count: number;
    
  }